import ReleaseOrderShareNote from './ReleaseOrderShareNote.component';

export default ReleaseOrderShareNote;
